/*
 * @Author: dongbo 254126189@qq.com
 * @Date: 2023-12-27 13:47:16
 * @LastEditors: dongbo 254126189@qq.com
 * @LastEditTime: 2024-01-25 10:44:05
 * @FilePath: /hippo-app-h5/hippo-app-h5/src/router/modules/albumlist.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/albumList/list',
    name: 'albumList',
    meta: {
      title: '车型亮点',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/albumList/index.vue'),
  },
]

export default routes
